const translations = {
    fr: {
      selectParcoursLabel: "Sélectionnez votre parcours",
      selectParcoursPlaceholder: "-- Choisir un parcours --",
      noParcoursAvailable: "Il n'y a actuellement aucun parcours disponible pour le village sélectionné.",
      startButton: "Démarrer"
    },
    en: {
      selectParcoursLabel: "Select your parcours",
      selectParcoursPlaceholder: "-- Choose a parcours --",
      noParcoursAvailable: "There are currently no parcours available for the selected village.",
      startButton: "Start"
    },
    de: {
      selectParcoursLabel: "Wählen Sie Ihre Route",
      selectParcoursPlaceholder: "-- Route wählen --",
      noParcoursAvailable: "Derzeit sind keine Routen für das ausgewählte Dorf verfügbar.",
      startButton: "Starten"
    },
    es: {
      selectParcoursLabel: "Selecciona tu recorrido",
      selectParcoursPlaceholder: "-- Elegir un recorrido --",
      noParcoursAvailable: "Actualmente no hay recorridos disponibles para el pueblo seleccionado.",
      startButton: "Comenzar"
    },
    it: {
      selectParcoursLabel: "Seleziona il tuo percorso",
      selectParcoursPlaceholder: "-- Scegli un percorso --",
      noParcoursAvailable: "Attualmente non ci sono percorsi disponibili per il villaggio selezionato.",
      startButton: "Inizia"
    }
  };
  
  export default translations;
  